<script setup>
import AppTopBarLink from "@/components/AppTopBarLink.vue";

import {inject} from "vue";
import UserMenu from "@/components/UserMenu.vue";
import MobileMenu from "@/components/MobileMenu.vue";
const user = inject('authenticatedUser');
const isAdmin = inject('isAdmin');
const isReviewer = inject('isReviewer');
</script>

<template>
    <div class="fixed top-0 h-16 left-0 right-0 z-3 w-screen">
        <div class="bg-nav"></div>
        <div class="!bg-transparent text-white absolute z-1 top-0 left-0 right-0 flex flex-row items-center h-16 px-5">
            <router-link to="/database" class="layout-topbar-logo mr-3">
                <img :src="'/images/balluff-2-logo-svg-vector.png'" alt="" width="130">
            </router-link>

            <div :class="['hidden', {'xl:flex': isAdmin, 'md:flex': !isAdmin}]">
                <app-top-bar-link v-if="isAdmin" to="/users">Users</app-top-bar-link>
                <app-top-bar-link to="/database">Database</app-top-bar-link>
                <app-top-bar-link to="/review">I have to review</app-top-bar-link>
                <app-top-bar-link to="/submitted">I have created</app-top-bar-link>
                <app-top-bar-link v-if="isAdmin" to="/database/in-review">Currently in review</app-top-bar-link>
                <app-top-bar-link v-if="isAdmin" to="/industries">Industries</app-top-bar-link>
                <app-top-bar-link v-if="isAdmin" to="/technology-trends">Technology/Trends</app-top-bar-link>
                <app-top-bar-link v-if="isAdmin" to="/countries">Countries</app-top-bar-link>
                <app-top-bar-link v-if="isAdmin" to="/activities">Activities</app-top-bar-link>
            </div>

            <div class="flex ml-auto gap-2">
                <user-menu />
                <mobile-menu :class="{'xl:hidden': isAdmin, 'md:hidden': !isAdmin}">
                    <app-top-bar-link v-if="isAdmin" to="/users">Users</app-top-bar-link>
                    <app-top-bar-link to="/database">Database</app-top-bar-link>
                    <app-top-bar-link to="/review">I have to review</app-top-bar-link>
                    <app-top-bar-link to="/submitted">I have created</app-top-bar-link>
                    <app-top-bar-link v-if="isAdmin" to="/database/in-review">Currently in review</app-top-bar-link>
                    <app-top-bar-link v-if="isAdmin" to="/industries">Industries</app-top-bar-link>
                    <app-top-bar-link v-if="isAdmin" to="/technology-trends">Technology/Trends</app-top-bar-link>
                    <app-top-bar-link v-if="isAdmin" to="/countries">Countries</app-top-bar-link>
                    <app-top-bar-link v-if="isAdmin" to="/activities">Activities</app-top-bar-link>
                </mobile-menu>
            </div>

        </div>
    </div>
</template>

<style lang="scss">
.bg-nav {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    height: 56px;
    background-image: url(/images/bg-main-header.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;

    &:after {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background-color: rgba(0,0,0,.3);
    }
}
</style>
